import { Greeting } from 'us-react-components/dist/Greeting/Greeting';
import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';
import { Booking } from 'us-web-services';
import { JoinFacebookGroup } from '../../components/Dashboard/JoinFacebookGroup';
import { useDependencies } from '../../dependencies';
import { DashboardBookings } from '../../components/Dashboard/DashboardBookings';

interface Props {
  activeBookings: Booking[];
}

const SideBar = ({ activeBookings }: Props): JSX.Element => {
  const { stores } = useDependencies();
  const { t } = useSharedTranslation(namespaces.caregiver);
  const { user: { user } } = stores;

  return (
    <div className='md:1/3 lg:w-80 md:mb-20'>
      <div className='flex mb-5'>
        <Greeting
          firstName={user.firstName || ''}
          description={t('components.greeting.findJob')}
          t={t}
        />
      </div>
      {activeBookings && activeBookings.length > 0 && (
      <div className='mb-5'>
        <div className='block font-bold mb-2.5'>{t('pages.sitter.dashboard.bookings.label')}</div>
        <DashboardBookings bookings={activeBookings}/>
      </div> )}
      <div className='hidden sm:block'>
        <JoinFacebookGroup />
      </div>
    </div>
  )
}

export { SideBar };
